import GroupType from '@linc-technologies/linced-common/enums/group-type';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export function getGroupVisibilityFilter(personId) {
  return (group) => {
    if (group.membershipHidden) {
      return false;
    }
    if (group.type === GroupType.GROUP) {
      // Omit My Groups which the current user isn't a current staff member in.
      let staff = group.get('currentStaff') ?? [];
      return !!findBy(staff, 'personId', personId);
    }
    // Include all other groups.
    return true;
  };
}
